import { render } from "./ResourceDetailSkeleton.vue?vue&type=template&id=0747c95e&scoped=true"
import script from "./ResourceDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./ResourceDetailSkeleton.vue?vue&type=script&lang=js"

import "./ResourceDetailSkeleton.vue?vue&type=style&index=0&id=0747c95e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0747c95e"]])

export default __exports__